import React, { useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { FooterProps } from '../index'
import classnames from 'classnames'
import ShopperApprovedWidget from '#src/app/components/Reviews/ShopperApprovedWidget'
import Copyright from '#src/app/components/Copyright'
import SocialMediaLink, { SocialMedia } from '#src/app/components/SocialMediaLink'
import PageContent from '#src/app/components/PageContent'
import { AnalyticsContext } from '#src/app/containers/Analytics'
import ArrowRight from './arrow-right.svg'
import sections from './data'
import styles from './styles.css'
import { Logo } from '@deal/components'

const Footer: React.FC<FooterProps> = ({ className, collapsedSections, hideWidget }) => {
  const analytics = useContext(AnalyticsContext)
  const initialArrMap: { [key: string]: boolean } = {}
  sections.forEach(section => {
    initialArrMap[section.label] = collapsedSections || false
  })

  const [collapsedSectionMap, updateCollapsedSectionMap] = useState<{ [key: string]: boolean }>(
    initialArrMap
  )

  return (
    <footer className={classnames(styles.sectionLight, className)}>
      <PageContent>
        <div className={styles.flexResponsive}>
          <div className={styles.flexResponsiveInverse}>
            {!hideWidget && <ShopperApprovedWidget />}

            <Link to="/" className={styles.logo}>
              <Logo color="dark" mark="icon" />
            </Link>
            <div className={styles.copywrite}>
              <Copyright />
            </div>
          </div>
          <div className={styles.optionsContainer}>
            {sections.map(({ label, links }) => {
              return (
                <div key={label} className={styles.group}>
                  <div
                    className={classnames(styles.groupTitle, {
                      [styles.collapsableGroupTitle]: collapsedSections
                    })}
                    onClick={() => {
                      if (collapsedSections) {
                        const curState = { ...collapsedSectionMap }
                        curState[label] = curState[label] ? false : true

                        updateCollapsedSectionMap(curState)
                      }
                    }}
                  >
                    <span className={styles.groupTitleLabel}>{label}</span>
                    {collapsedSections && (
                      <ArrowRight
                        className={classnames(styles.collapseArrow, {
                          [styles.activated]: !collapsedSectionMap[label]
                        })}
                      />
                    )}
                  </div>
                  <div
                    className={classnames(styles.links, {
                      [styles.collapsed]: collapsedSectionMap[label]
                    })}
                  >
                    {links.map(({ label, link, isSocial }) =>
                      isSocial ? (
                        <SocialMediaLink
                          key={label}
                          target="_blank"
                          className={styles.groupItem}
                          socialMedia={link as SocialMedia}
                        >
                          {label}
                        </SocialMediaLink>
                      ) : (
                        <Link
                          key={label}
                          to={link}
                          className={styles.groupItem}
                          onClick={() => {
                            if (link === '/journal') {
                              analytics?.events.trackArticleHubEntryPointClicked({
                                entry_point: 'footer'
                              })
                            }
                          }}
                        >
                          {label}
                        </Link>
                      )
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </PageContent>
    </footer>
  )
}

export default Footer
